export default __webpack_public_path__ + "static/media/close_e.9edcfa8e.svg";